export default __webpack_public_path__ + "static/media/zeta.117efea1.png";